import React from "react";
import "./card-information.styles.css";

/**
 * @param {{ children: import('react').ReactNode, type: "info" | "warning" | "error", className: string }} props
 */
const CardInformation = ({ children, type, className = "" }) => {
  return (
    <div className={`card-information-new ${type} ${className}`}>
      {children}
    </div>
  );
};

export default CardInformation;
